import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalMessageService, RoutingService, TranslationService, GlobalMessageType, I18nModule } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import InventoryManagementService from '../../custom-landing/inventory-unpublished-batch/inventory-management.service';
import { CustomLoginService } from '../custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf } from '@angular/common';
import { PasswordStrengthMeterComponent } from '../../../shared/password-strength-meter/password-strength-meter.component';

@Component({
    selector: 'app-custom-update-password',
    templateUrl: './custom-update-password.component.html',
    styleUrls: ['./custom-update-password.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, FormsModule, ReactiveFormsModule, NgIf, FormErrorsComponent, PasswordStrengthMeterComponent, I18nModule]
})
export class CustomUpdatePasswordComponent implements OnInit {
  updatePasswordForm: UntypedFormGroup;
  title: any;
  navigationData: string;
  userName: any;
  token: any;
  privacyPolicyStr: any;
  termsOfUseStr: any;
  isDisabled:boolean=false
  @Output()
  submitted = new EventEmitter<{ oldPassword: string; newPassword: string }>();

  @Output()
  cancelled = new EventEmitter<void>();
  error: any;
  upper: string;
  writeAccess: any;
  isCustomerEmulated: boolean;
  termsOfUsePartner: any;
  chinaInstance:any;

  constructor(private fb: UntypedFormBuilder, private translation: TranslationService, private routingService: RoutingService,
              private customProfileService: CustomProfileService, private userAccountFacade: UserAccountFacade,
              private cd: ChangeDetectorRef, private customProductService: CustomProductsService,
              private toastService: ToastrService, protected  globalMessageService: GlobalMessageService,
              private inventoryManagementService: InventoryManagementService,
              private customloginservice:CustomLoginService, private csAgentAuthService:CsAgentAuthService) { }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.getFooterData();
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isDisabled = true;
        }else{
          this.isDisabled = false;
        }
      })
    })
    this.customProductService.getHomeLinkActive(false);
    this.updatePasswordForm = new UntypedFormGroup({
      newPassword: new UntypedFormControl(),
      newPasswordConfirm: new UntypedFormControl(),
   });
   this.translation.translate('breadcrumb.resetPassword.pageTitle').subscribe(res => {
    this.title = res;
  });
  this.translation.translate('breadcrumb.resetPassword.breadcrumb').subscribe(res => {
    this.navigationData = res;
  });
    this.userAccountFacade.get().subscribe(data => {
      if (data) {
        this.userName = data.uid;
        this.getPasswordToken();
        this.cd.detectChanges();
      }
    });

    this.updatePasswordForm = this.fb.group(
      {
        // oldPassword: [null, [Validators.required]],
        newPassword: ['', [Validators.required,Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%*]).{8}/)]],
        newPasswordConfirm: ['', [Validators.required]],
      },
      {
        validators: CustomFormValidators.passwordsMustMatch(
          'newPassword',
          'newPasswordConfirm'
        ),
      }
    );
  }
  // tslint:disable-next-line:typedef
  onSubmit(): void {
    const { newPassword } = this.updatePasswordForm.controls;
    this.customProfileService.resetPassword(this.token, newPassword.value).subscribe(
      data => {
        if (data.success || data.error){
          if (data.success){
            this.customProductService.getHomeLinkActive(false);
            this.toastService.show(data.success);
            this.routingService.go({
              cxRoute: 'login',
            });
          }else if (data.error){
           // this.showError = true;
            this.globalMessageService.add(data.error, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }else{
          if (data === 'success') {
            this.routingService.go({
              cxRoute: ''
            });
          }else{
            this.toastService.show(this.error);
          }
        }
      }
    );
    if (this.updatePasswordForm.valid) {
      this.submitted.emit({
        oldPassword: this.updatePasswordForm.value.oldPassword,
        newPassword: this.updatePasswordForm.value.newPassword,
      });
    } else {
      this.updatePasswordForm.markAllAsTouched();
    }

  }

  getPasswordToken(): any {
    this.customProfileService.changePasswordToken(this.userName).subscribe(
      data => {
        if (data.success || data.error){
          if (data.success){
            this.token = data.success;
          }else if (data.error){
            this.globalMessageService.add(data.error, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }else{
          if (!data.error) {
            this.token = data;
          }else{
           // this.toastService.show(this.error);
          }
        }
      }
    );
  }
  // tslint:disable-next-line:typedef
  onStrengthChange(strength) {
  }
  onCancel(): void {
    this.routingService.go({
      cxRoute: 'home'
    });
  }
  getFooterData() {
    this.customProductService.privacyPolicyValue.subscribe((resp: any)=>{
  
    // if(resp.chinaInstanceCheck == 'true'){
      this.privacyPolicyStr = resp.privacyPolicy;
      this.termsOfUseStr = resp.termsOfUse;
      this.termsOfUsePartner = resp.termsOfUsePartner?resp.termsOfUsePartner:"";
      this.chinaInstance= resp.chinaInstanceCheck;
    // }
    // else{
    //   this.privacyPolicyStr = 'https://www.bhp.com/privacy-policy';
    //   this.termsOfUseStr = 'https://www.bhp.com/terms-of-use';
    // }
    this.cd.detectChanges();
  });
}
}
